import React from 'react';
import ReactDom from 'react-dom';
import { IntlProvider } from 'react-intl';

import HeaderPrice from 'contest/components/header-price';

const renderHeaderPrice = (priceData) => {
    const intlData = JSON.parse(priceData.getAttribute('data-translations'));
    const initialProps = JSON.parse(priceData.getAttribute('data-initial-props'));

    return (
        <IntlProvider locale={document.documentElement.lang} messages={intlData.messages}>
            <HeaderPrice {...initialProps} />
        </IntlProvider>
    );
};

const priceData = document.getElementById('header-price-data');
if (priceData) {
    document.addEventListener('DOMContentLoaded', () => {
        ReactDom.render(
            renderHeaderPrice(priceData),
            document.getElementById('header-price-mount')
        );
    });
}



// WEBPACK FOOTER //
// ./src/web/js/contest/header-price.jsx